import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Tooltip } from "antd";

dayjs.extend(relativeTime);

interface TimestampCellProps {
  value: string;
}

export const TimestampCell: React.FC<TimestampCellProps> = ({ value }) => {
  if (!value) {
    return <span>N/A</span>;
  }

  return (
    <Tooltip title={dayjs(value).format("D.M.YYYY HH:mm:ss")}>
      {dayjs(value).fromNow()}
    </Tooltip>
  );
};
